
import { createClient } from '@supabase/supabase-js';
import type { Database } from './types';

const SUPABASE_URL = "https://zxazeodvlaknalnuxtur.supabase.co";
const SUPABASE_ANON_KEY = "eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpc3MiOiJzdXBhYmFzZSIsInJlZiI6Inp4YXplb2R2bGFrbmFsbnV4dHVyIiwicm9sZSI6ImFub24iLCJpYXQiOjE3MzM5MTczNTUsImV4cCI6MjA0OTQ5MzM1NX0.fJUzW4GkpthX0pwpOxC7YyMtVWTLXPvx4U00ygNhS_c";

export const supabase = createClient<Database>(
  SUPABASE_URL,
  SUPABASE_ANON_KEY,
  {
    auth: {
      autoRefreshToken: true,
      persistSession: true,
      detectSessionInUrl: true,
      storage: typeof window !== 'undefined' ? window.localStorage : undefined,
      storageKey: 'offertio_supabase_auth',
      flowType: 'pkce'
    },
    realtime: {
      params: {
        eventsPerSecond: 10
      }
    }
  }
);
